import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH ALL PRODUCTS ================= */
export const fetchProducts = createAsyncThunk(
  "product/fetchAll",
  async ({ page = 1, limit = 100, search = "", type = "all" } = {}, thunkAPI) => {
    try {
      const res = await api.get(
        `/api/products?page=${page}&limit=${limit}&search=${search}&type=${type}`
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to fetch products");
    }
  }
);

/* ================= FETCH PRODUCT BY ID ================= */
export const fetchProductById = createAsyncThunk(
  "product/fetchById",
  async (id, thunkAPI) => {
    try {
      const res = await api.get(`/api/products/${id}`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to fetch product");
    }
  }
);

/* ================= TOGGLE PRODUCT STATUS ================= */
export const toggleProductStatus = createAsyncThunk(
  "product/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/products/${id}/status`);
      return res.data.data;
    } catch {
      return thunkAPI.rejectWithValue("Failed to toggle status");
    }
  }
);

/* ================= TOGGLE PRODUCT POPULAR ================= */
export const toggleProductPopular = createAsyncThunk(
  "product/togglePopular",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/products/${id}/popular`);
      return res.data.data;
    } catch {
      return thunkAPI.rejectWithValue("Failed to toggle popular status");
    }
  }
);

/* ================= SLICE ================= */
const productSlice = createSlice({
  name: "product",
  initialState: {
    loading: false,
    error: null,
    products: [],
    pagination: {},
    currentProduct: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* fetchAll */
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* fetchById */
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentProduct = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentProduct = action.payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* toggleStatus */
      .addCase(toggleProductStatus.fulfilled, (state, action) => {
        const idx = state.products.findIndex((p) => p._id === action.payload._id);
        if (idx !== -1) state.products[idx].status = action.payload.status;
        if (state.currentProduct?._id === action.payload._id) {
          state.currentProduct.status = action.payload.status;
        }
      })
            /* togglePopular */
      .addCase(toggleProductPopular.fulfilled, (state, action) => {
        const idx = state.products.findIndex((p) => p._id === action.payload._id);
        if (idx !== -1) state.products[idx].isPopular = action.payload.isPopular;
        if (state.currentProduct?._id === action.payload._id) {
          state.currentProduct.isPopular = action.payload.isPopular;
        }
      });
  },
});

export default productSlice.reducer;